// 商详页，默认展示所有尺码
// (function () {
//   try {
//     const urlParams = new URLSearchParams(window.location.search);
//     const variantId = urlParams.get("variant"); // 直接获取 variant 参数的值

//     // 定义需要执行的脚本，并返回是否移除了类名
//     // function removeSoldoutClasses() {
//     //   const elements = document.querySelectorAll(
//     //     ".t4s-swatch__item.is--soldout.is--unavailable"
//     //   );
//     //   let hasRemoved = false;

//     //   if (elements.length === 0) {
//     //     console.log(">>> 未找到需要处理的元素");
//     //     return false; // 无元素可处理，继续监听
//     //   }

//     //   elements.forEach((element) => {
//     //     // 检查元素是否真的包含目标类名
//     //     if (
//     //       element.classList.contains("is--soldout") ||
//     //       element.classList.contains("is--unavailable")
//     //     ) {
//     //       console.log(">>> 找到元素，开始显示所有尺码选项");
//     //       element.classList.remove("is--soldout", "is--unavailable");
//     //       hasRemoved = true;
//     //     }
//     //   });

//     //   return hasRemoved; // 返回是否执行了移除操作
//     // }

//     // 监听表单变化的逻辑
//     function observeFormChanges() {
//       const targetForm = document.querySelector('form[action="/cart/add"]');

//       console.log(">>> 找到元素，开始观察");

//       if (!targetForm) {
//         console.warn('>>> 未找到表单元素 form[action="/cart/add"]');
//         return;
//       }

//       const observer = new MutationObserver((mutations, observer) => {
//         // 执行脚本，并根据返回值决定是否停止监听
//         const isSuccess = removeSoldoutClasses();

//         if (isSuccess) {
//           console.log(">>> 类名已移除，停止监听");
//           observer.disconnect();
//         } else {
//           console.log(">>> 未移除类名，继续监听");
//         }
//       });

//       // 配置观察选项
//       const config = {
//         attributes: true,
//         childList: true,
//         subtree: true,
//       };

//       observer.observe(targetForm, config);
//     }

//     // 初始化监听
//     // if (!variantId) {
//     //   console.log(">>> 未检测到 ID，开始移除样式");
//     //   document.addEventListener("DOMContentLoaded", observeFormChanges);
//     // } else {
//     //   console.log(">>> 有 ID，无须移除样式");
//     // }
//   } catch (e) {
//     console.error(e);
//   }
// })();

// 红人模块移动到指定的位置
(function () {
  try {
    function moveAAfterBOnHeightChange() {
      const $A = $(".custom-image-gallery");
      const $B = $(".mibao_product_1_percent");
      const $wrapper = $(".t4s-product-tabs-wrapper");

      const resetHeight = function () {
        const $container = $A.find(".flickityt4s-viewport");
        const h = $container.find(".t4s-img-wrap").height();
        h && $container.parent().height(h).css({ overflow: "hidden" });
      };

      // 如果关键元素不存在，直接退出
      if (!$A.length || !$B.length || !$wrapper.length) return;

      // 初始化的时候移动一次
      $A.insertAfter($B);
      resetHeight();

      // 记录初始高度
      const wrapperEl = $wrapper[0];
      let lastHeight = wrapperEl.offsetHeight;
      let isInited = false;

      const observer = new MutationObserver(() => {
        const newHeight = wrapperEl.offsetHeight;

        console.log(">>>> Math.abs:", Math.abs(newHeight - lastHeight));

        // 处理高度

        // 处理移动（位置）
        if (!isInited && $(".cbb-frequently-bought-container").length) {
          $A.insertAfter($B);
          isInited = true;
          console.log(">>>> module moved");
        }

        if (Math.abs(newHeight - lastHeight) > 2) {
          resetHeight();
          lastHeight = newHeight;
          console.log(">>>> reset height.");
        }
      });
      observer.observe(wrapperEl, {
        childList: true, // 监听子元素变化
        subtree: true, // 监听所有后代元素
        attributes: true,
      });
    }

    document.addEventListener("DOMContentLoaded", function () {
      moveAAfterBOnHeightChange();
    });
  } catch (error) {
    console.log(">>> 红人模块移动失败:", error);
  }
})();

// 处理 You May Also Like 的容齐高度问题，强制适配内容高度
(function () {
  try {
    // 防抖函数（避免频繁触发）
    function debounce(func, delay) {
      let timeout;
      return function () {
        clearTimeout(timeout);
        timeout = setTimeout(() => func.apply(this, arguments), delay);
      };
    }

    let preHeight = 0;

    // 主逻辑：计算并设置高度
    function updateSliderHeight() {
      $(".id_product-recommendations").each(function (idx, ele) {
        const $ele = $(ele);
        let height = 0;

        $ele.find(".t4s-product").each(function (_idx, _ele) {
          const $item = $(_ele);
          const h = $item.outerHeight(true); // 包含 margin/padding
          if (h > height) height = h;
        });

        if (height > 0 && Math.abs(preHeight - height) > 2) {
          const $viewport = $ele.find(".flickityt4s-viewport");
          $viewport.height(height);
          preHeight = height;
          console.log(">>>> execute reset height.");
        }
      });
    }

    // 配置 MutationObserver
    const observer = new MutationObserver(
      debounce(function (mutations) {
        mutations.forEach((mutation) => {
          updateSliderHeight();
        });
      }, 300)
    ); // 防抖 300ms

    const config = {
      childList: true, // 监听子元素增减
      subtree: true, // 监听所有后代元素
    };

    document.addEventListener("DOMContentLoaded", function () {
      // 初始化监听
      $(".id_product-recommendations").each(function (idx, ele) {
        observer.observe(ele, config);
      });

      // 首次执行
      updateSliderHeight();
    });
  } catch (e) {
    console.error(">>>> 高度重置错误:", e);
  }
})();

// 异步获取new、hot标签同时挂载到DOM
(function getProductSkuTag() {
  document.addEventListener('DOMContentLoaded', async () => {
    try {
      const spu = meta?.product?.variants[0]?.sku.split('-').slice(0, 2).join('-')
      const res = await window.ogl_fetch.get('/api/v1/spu-attribute-tag/get-spu-attribute-by-spu', { spu, site_id: window.ogl_config.site.id })
      console.log('res-----', res)
      const config = res.data[spu]
      if (config) {
        const hots = config?.hot || [];
        const news = config?.new || [];
        console.log('hots:', hots, 'news:', news);
        // 添加 hot 标签
        hots.forEach(hot => {
          $(`[data-swatch-item][data-value="${hot}"]`).addClass('hot');
        });
        // 添加 new 标签
        news.forEach(_new => {
          $(`[data-swatch-item][data-value="${_new}"]`).addClass('new');
        })
      }
    } catch (error) {
      console.error(error)
    }
  })
})()
